import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import {
  IsBoolean,
  IsNumber,
  IsOptional,
  ValidateNested,
} from 'class-validator';
import { GeographyPointDto } from '../../common/dto/geography-point.dto';

/**
 * Body of POST /job-phase/:id/approve. Approves the phase and, for the paint
 * phases, records the interior/exterior option completion on the job in the
 * same transaction (the admin used to PATCH job-phase then PATCH job).
 */
export class JobPhaseApproveDto {
  @ApiPropertyOptional({ type: () => GeographyPointDto })
  @Expose()
  @IsOptional()
  @ValidateNested()
  @Type(() => GeographyPointDto)
  approvedGeo?: GeographyPointDto;

  @ApiPropertyOptional({ type: 'number' })
  @Expose()
  @IsOptional()
  @IsNumber()
  approvedGeoAccuracy?: number;

  @ApiPropertyOptional({
    type: 'boolean',
    description: 'Trim option selection, finalized on the job by the approval.',
  })
  @Expose()
  @IsOptional()
  @IsBoolean()
  trimOptionSelected?: boolean;

  @ApiPropertyOptional({
    type: 'boolean',
    description:
      'Interior options completed in this phase (Interior Paint / Final Paint only).',
  })
  @Expose()
  @IsOptional()
  @IsBoolean()
  interiorOptionsCompleted?: boolean;

  @ApiPropertyOptional({
    type: 'boolean',
    description:
      'Exterior options completed in this phase (Interior Paint / Final Paint only).',
  })
  @Expose()
  @IsOptional()
  @IsBoolean()
  exteriorOptionsCompleted?: boolean;
}
